export default function CompanyOverviewSection() {
  return (
    <section className="bg-white-warm w-full py-28 px-6 relative overflow-hidden">
      
      {/* Background Graphic Accents */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "repeating-linear-gradient(90deg, rgba(1,46,114,0.03) 0px, rgba(1,46,114,0.03) 1px, transparent 1px, transparent 80px)",
        }}
      />
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none filter blur-[140px]"
        style={{ backgroundColor: "rgba(1,46,114,0.03)" }}
      />

      <div className="max-w-3xl mx-auto relative">
        <div className="flex flex-col items-center text-center gap-8">

          {/* Context Badge */}
          <div className="flex items-center gap-3">
            <span
              className="font-cinzel text-blue-dark uppercase tracking-widest font-medium"
              style={{ fontSize: "11px", letterSpacing: "0.25em", opacity: 0.75 }}
            >
              — Company Overview —
            </span>
          </div>

          {/* Display Heading */}
          <h2
            className="font-cinzel font-bold text-blue-dark uppercase"
            style={{
              fontSize: "clamp(28px, 4.5vw, 44px)",
              letterSpacing: "0.05em",
              lineHeight: "1.2",
            }}
          >
            A Legacy of<br />
            <span className="italic font-normal opacity-80 text-[0.95em] lowercase tracking-normal">with</span> Protection &amp; Trust
          </h2>

          {/* Architectural Separator */}
          <div className="flex items-center gap-4">
            <div className="h-px w-16 bg-blue-dark opacity-20" />
            <div className="w-1 h-1 rotate-45 bg-blue-dark opacity-40" />
            <div className="h-px w-16 bg-blue-dark opacity-20" />
          </div>

          {/* Elegant Prose Copy */}
          <div
            className="flex flex-col gap-5 font-constantia text-black-deep leading-relaxed max-w-2xl"
            style={{ fontSize: "16.5px", opacity: 0.8 }}
          >
            <p>
              Paladin Professional Insurance Solutions operates as a bespoke independent 
              agency, engineered to provision premium protection across complex personal, 
              commercial, and specialty risk classifications.
            </p>
            <p>
              Recognizing that exposure profiles resist standardization, we reject boilerplate 
              structures. Our team deploys an analytical, consultative matrix to customize 
              portfolios perfectly calibrated to your operations and private capital.
            </p>
          </div>

          {/* Premium Stat Grid Mosaic */}
          <div 
            className="grid grid-cols-3 gap-8 sm:gap-16 pt-10 mt-6 border-t w-full max-w-xl justify-center" 
            style={{ borderColor: "rgba(1,46,114,0.15)" }}
          >
            {[
              { value: "20+", label: "Years of Practice" },
              { value: "9", label: "Licensed States" },
              { value: "1k+", label: "Clients Secured" },
            ].map(({ value, label }) => (
              <div key={label} className="flex flex-col items-center gap-2 group">
                <span
                  className="font-cinzel font-bold text-blue-dark transition-transform duration-300 group-hover:translate-y-[-1px]"
                  style={{ fontSize: "clamp(24px, 3.5vw, 32px)", lineHeight: 1, letterSpacing: "-0.02em" }}
                >
                  {value}
                </span>
                <div className="h-[2px] w-4 bg-blue-dark opacity-20 transition-all duration-300 group-hover:w-8" />
                <span
                  className="font-constantia text-black-deep uppercase tracking-wider text-center"
                  style={{ fontSize: "10px", opacity: 0.55, letterSpacing: "0.05em", lineHeight: "1.3" }}
                >
                  {label}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}